// extracted by mini-css-extract-plugin
export default {"container":"oZ-z","title":"pZ-z","link":"qZ-z"};